import { themeColor } from './theme/themeVariables';

const config = {
  topMenu: true,
  rtl: false,
  mainTemplate: 'lightMode',
  themeColor,
};

export default config;
